
import { mapGetters } from "vuex";
export default {
    props: ['title', 'message', 'content'],
    computed: {
        ...mapGetters({
            getterTranslates: 'getterTranslates',
            getterStoreLang	: 'getterStoreLang'
        }),
	},
}
